import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 3;\n  padding: 15px 20px;\n  align-items: center;\n\n  background: ', ';\n  color: ', ';\n  font-size: ', ';\n\n  & :first-child {\n    margin-right: 14px;\n  }\n'], ['\n  display: flex;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 3;\n  padding: 15px 20px;\n  align-items: center;\n\n  background: ', ';\n  color: ', ';\n  font-size: ', ';\n\n  & :first-child {\n    margin-right: 14px;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  margin-top: 4px;\n  cursor: pointer;\n  text-decoration: underline;\n'], ['\n  margin-top: 4px;\n  cursor: pointer;\n  text-decoration: underline;\n']);

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { styles, translations } from 'gipsy-misc';
import FaRetweet from 'react-icons/lib/fa/retweet';
import FaPencil from 'react-icons/lib/fa/pencil';

var Container = styled.div(_templateObject, function (_ref) {
  var mode = _ref.mode;
  return mode === 'standard' ? styles.colors.backgroundGreyColor : '#f0ecff';
}, function (_ref2) {
  var mode = _ref2.mode;
  return mode === 'standard' ? styles.colors.textRegularColor : styles.colors.primaryColor;
}, styles.fonts.fontSizeXSmall);

var Prompt = styled.div(_templateObject2);

var RecurrencyModeSwitch = function (_PureComponent) {
  _inherits(RecurrencyModeSwitch, _PureComponent);

  function RecurrencyModeSwitch() {
    _classCallCheck(this, RecurrencyModeSwitch);

    return _possibleConstructorReturn(this, (RecurrencyModeSwitch.__proto__ || Object.getPrototypeOf(RecurrencyModeSwitch)).apply(this, arguments));
  }

  _createClass(RecurrencyModeSwitch, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          task = _props.task,
          onEditModeChange = _props.onEditModeChange,
          mode = _props.mode,
          editMode = _props.editMode;


      var show = task && task.recurrencyDetails && mode === 'edit';
      var texts = translations.taskPanel.recurrency;
      var start = editMode === 'standard' ? texts.standardEditStart : texts.recurringEditStart;
      var prompt = editMode === 'standard' ? texts.recurringEditPrompt : texts.standardEditPrompt;
      var Icon = editMode === 'standard' ? FaPencil : FaRetweet;
      return show ? React.createElement(
        Container,
        { show: show, mode: editMode },
        React.createElement(Icon, { size: 18 }),
        React.createElement(
          'div',
          null,
          React.createElement(
            'div',
            null,
            start
          ),
          React.createElement(
            Prompt,
            { onClick: function onClick() {
                return onEditModeChange(editMode === 'standard' ? 'recurring' : 'standard');
              } },
            prompt
          )
        )
      ) : '';
    }
  }]);

  return RecurrencyModeSwitch;
}(PureComponent);

RecurrencyModeSwitch.propTypes = {
  task: PropTypes.object,
  onEditModeChange: PropTypes.func,
  mode: PropTypes.string,
  editMode: PropTypes.string
};


export default RecurrencyModeSwitch;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/components/Header/RecurrencyModeSwitch/index.js
// module id = 1095
// module chunks = 0